import { defineMessages } from "react-intl";

export const orderPrintMessages = defineMessages({
  printShippingLabelButton: {
    id: "3IxzjO",
    defaultMessage: "Print shipping label",
    description: "order details top bar button, opens the shipping label print preview",
  },
  printPickupTicketButton: {
    id: "Fz+sxy",
    defaultMessage: "Print pickup ticket",
    description: "order details top bar button, opens the in-store pickup ticket print preview",
  },
  shippingLabelTitle: {
    id: "y/fNek",
    defaultMessage: "Shipping label",
    description: "print dialog title",
  },
  pickupTicketTitle: {
    id: "kuBg4F",
    defaultMessage: "In-store pickup ticket",
    description: "print dialog title",
  },
  showOnLabel: {
    id: "X/NLMc",
    defaultMessage: "Show on the label",
    description: "print dialog, heading of the optional shipping label lines",
  },
  fieldAll: {
    id: "pCoeAr",
    defaultMessage: "All",
    description: "print dialog, select/unselect every optional shipping label line",
  },
  fieldOrderNumber: {
    id: "szwqJd",
    defaultMessage: "Order number",
    description: "print dialog, optional shipping label line",
  },
  fieldShippingMethod: {
    id: "WRNqGK",
    defaultMessage: "Shipping method",
    description: "print dialog, optional shipping label line",
  },
  fieldItemCount: {
    id: "TzHyW0",
    defaultMessage: "Number of items",
    description: "print dialog, optional shipping label line",
  },
  fieldPrintedAt: {
    id: "ZmyFY4",
    defaultMessage: "Print date and time",
    description: "print dialog, optional shipping label line",
  },
  paper: {
    id: "q9Nt2q",
    defaultMessage: "Paper",
    description: "print dialog, paper size select label",
  },
  paperA5: {
    id: "3Y5P71",
    defaultMessage: "A5 portrait (half A4) — 148 × 210 mm",
    description: "print dialog paper option",
  },
  paperA4Half: {
    id: "3KHayq",
    defaultMessage: "A4 sheet, top half — cut along the line",
    description: "print dialog paper option",
  },
  paperLabel100x150: {
    id: "mlFnhf",
    defaultMessage: "Label printer — 100 × 150 mm",
    description: "print dialog paper option",
  },
  paperRoll80: {
    id: "XUB12k",
    defaultMessage: "Receipt roll — 80 mm",
    description: "print dialog paper option",
  },
  paperRoll58: {
    id: "dEoD12",
    defaultMessage: "Receipt roll — 58 mm",
    description: "print dialog paper option",
  },
  paperA4: {
    id: "xGoVmQ",
    defaultMessage: "A4 sheet",
    description: "print dialog paper option",
  },
  pageSizeHint: {
    id: "3nGfOq",
    defaultMessage:
      "Page size sent to the printer: {size}. If the print dialog shows another size, pick this one there.",
    description: "print dialog hint under the paper select",
  },
  print: {
    id: "4a6HcZ",
    defaultMessage: "Print",
    description: "print dialog primary button",
  },
  cancel: {
    id: "XqEWzJ",
    defaultMessage: "Close",
    description: "print dialog secondary button",
  },
  missingCompanyAddress: {
    id: "oNLwef",
    defaultMessage:
      "The shop has no company address yet, so the sender block only shows the shop name. Set it in Configuration → Site settings.",
    description: "print dialog warning",
  },
  missingShippingAddress: {
    id: "qVSCPH",
    defaultMessage: "This order has no shipping address.",
    description: "print dialog warning",
  },
  pickupPointInput: {
    id: "0NjXsb",
    defaultMessage: "Pickup point (Ponto de Recolha) address",
    description: "print dialog input for the GLS pickup point address printed on the label",
  },
  pickupPointInputHelp: {
    id: "6oitUr",
    defaultMessage:
      "Pre-filled with the address recorded on the order. Changes here only affect this print.",
    description: "print dialog helper text under the pickup point input",
  },
  pickupPointMissing: {
    id: "LdcL2L",
    defaultMessage:
      "No pickup point recorded yet. Type the pickup point address to print it on the label.",
    description: "print dialog warning for parcel-shop orders without a recorded pickup point",
  },
  missingPin: {
    id: "Qkeig3",
    defaultMessage:
      "This order has no pickup PIN yet. It is created when you mark the order ready for pickup.",
    description: "print dialog warning for in-store pickup orders without a PIN",
  },
  // Printed document texts
  from: {
    id: "3wcy88",
    defaultMessage: "From",
    description: "shipping label, sender block heading",
  },
  to: {
    id: "IAbrv5",
    defaultMessage: "To",
    description: "shipping label, recipient block heading",
  },
  pickupPointBadge: {
    id: "AbMHPp",
    defaultMessage: "Pickup point",
    description: "shipping label badge for GLS parcel-shop (Ponto de Recolha) deliveries",
  },
  pickupPointRecipient: {
    id: "1IYCs4",
    defaultMessage: "Customer to collect",
    description: "shipping label, name of the customer who collects the parcel at a pickup point",
  },
  pickupPointAddress: {
    id: "2SQK0q",
    defaultMessage: "Deliver to pickup point",
    description: "shipping label heading above the pickup point address",
  },
  phone: {
    id: "tye2fD",
    defaultMessage: "Phone: {phone}",
    description: "printed phone number",
  },
  orderNumber: {
    id: "AaoKip",
    defaultMessage: "Order #{number}",
    description: "printed order number",
  },
  shippingMethod: {
    id: "/EfjK2",
    defaultMessage: "Shipping: {method}",
    description: "shipping label, shipping method name",
  },
  itemCount: {
    id: "ZhSEgx",
    defaultMessage: "{count, plural, one {# item} other {# items}}",
    description: "printed number of items in the order",
  },
  ticketHeading: {
    id: "iQ6NtO",
    defaultMessage: "In-store pickup",
    description: "pickup ticket heading",
  },
  ticketOrder: {
    id: "WNCINT",
    defaultMessage: "Order",
    description: "pickup ticket, label above the big order number",
  },
  ticketOrderDate: {
    id: "8p4qE2",
    defaultMessage: "Ordered: {date}",
    description: "pickup ticket, order date",
  },
  ticketCustomer: {
    id: "fNa4da",
    defaultMessage: "Customer",
    description: "pickup ticket section heading",
  },
  ticketPin: {
    id: "SRHkBo",
    defaultMessage: "Pickup PIN",
    description: "pickup ticket, label above the PIN",
  },
  ticketPinHint: {
    id: "RcT8Bz",
    defaultMessage: "Hand over only if the customer's PIN matches",
    description: "pickup ticket, note under the PIN",
  },
  ticketNoPin: {
    id: "aYRIrP",
    defaultMessage: "No PIN",
    description: "pickup ticket, shown instead of the PIN when none was created",
  },
  ticketItems: {
    id: "Eu/b8O",
    defaultMessage: "Items",
    description: "pickup ticket section heading",
  },
  ticketSignature: {
    id: "coo3or",
    defaultMessage: "Customer signature",
    description: "pickup ticket, signature line",
  },
  ticketCollectedOn: {
    id: "DAjy3m",
    defaultMessage: "Collected on",
    description: "pickup ticket, date line filled in by hand",
  },
  printedAt: {
    id: "ZdL1tH",
    defaultMessage: "Printed: {date}",
    description: "printed timestamp at the bottom of tickets and labels",
  },
});
